/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillCartShareEventsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeBackfillCartShareEventsRequest, serializeBackfillCartShareEventsResponse, type BackfillCartShareEventsRequest, type BackfillCartShareEventsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/carts/backfill-share-events
 */
export interface BackfillShareEventsRequestBuilder extends BaseRequestBuilder<BackfillShareEventsRequestBuilder> {
    /**
     * Records every cart share in this organization that reached someone and is not on its cart's Activity yet as a 'Shared cart' event, with the original send time, the rep who sent it, how it went out and to whom. Runs dry by default — send dryRun:false to write. Safe to re-run: a share already recorded (when it was sent, or by an earlier run) is counted and left alone.
     * @param body Request to record an organization's earlier cart shares on their carts' Activity.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillCartShareEventsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: BackfillCartShareEventsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillCartShareEventsResponse | undefined>;
    /**
     * Records every cart share in this organization that reached someone and is not on its cart's Activity yet as a 'Shared cart' event, with the original send time, the rep who sent it, how it went out and to whom. Runs dry by default — send dryRun:false to write. Safe to re-run: a share already recorded (when it was sent, or by an earlier run) is counted and left alone.
     * @param body Request to record an organization's earlier cart shares on their carts' Activity.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BackfillCartShareEventsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BackfillShareEventsRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/carts/backfill-share-events";
/**
 * Metadata for all the requests in the request builder.
 */
export const BackfillShareEventsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BackfillShareEventsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillCartShareEventsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBackfillCartShareEventsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
